import {
    Col, Row
} from "antd";
import "./index.scss";
const MenuLeft = () => {
    return (
        <Col span={24} style={{ background: 'white', margin: '20px 0px 40px 0px', bottom: -0, height: 30, padding: '23px 15px', lineHeight: '0px', borderRadius: 10 }} className='footer-main'>
            <Row justify="space-between">
                <Col span={12} xs={24} sm={24} md={24} lg={12} xl={12} xxl={12}>Copyright © 2022 <b>Ghiền Tech</b></Col>
                <Col span={12} style={{ textAlign: 'right' }} xs={0} sm={0} md={0} lg={12} xl={12} xxl={12}><b>Powered by Ghiền Tech</b></Col>
            </Row>
        </Col>
    );
};
export default MenuLeft;
